module.exports = __webpack_public_path__ + "static/media/6COPUOS4.f0292ffb.jpg";